import type { NavigationKey } from '@/types';
import type { CommandPaletteItem } from '@/components/CommandPalette';

export const BASE_OPTIONS: readonly CommandPaletteItem<NavigationKey>[] = [
  {
    value: '/D',
    prefix: '/',
    hotkey: 'D',
    label: 'Dashboard',
    accent: '#f15a2b',
  },
  { value: '/T', prefix: '/', hotkey: 'T', label: 'Tasks', accent: '#8b5cf6' },
  { value: '/C', prefix: '/', hotkey: 'C', label: 'Cases', accent: '#0f9bb0' },
  { value: '/F', prefix: '/', hotkey: 'F', label: 'Files', accent: '#16a34a' },
];

export const PRACTICE_OPTIONS: readonly CommandPaletteItem<NavigationKey>[] = [
  ...BASE_OPTIONS,
  {
    value: '/P',
    prefix: '/',
    hotkey: 'P',
    label: 'Patients',
    accent: '#2e6bff',
  },
];

export const LAB_OPTIONS: readonly CommandPaletteItem<NavigationKey>[] = [
  ...BASE_OPTIONS,
  {
    value: '/P',
    prefix: '/',
    hotkey: 'P',
    label: 'Customers',
    accent: '#2e6bff',
  },
];
